import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useSession } from 'next-auth/react'
import { Routes } from 'constants/common/routes'

export const useLoginCallback = () => {
  const router = useRouter()
  const { status } = useSession()

  useEffect(() => {
    if (status === 'authenticated') {
      const callbackUrl = decodeURIComponent((router.query?.callbackUrl as string) || Routes.Home())
      void router.push(callbackUrl)
    }
  }, [status, router])
}
